export enum OVERLAYS {
    OVERLAY_RESET_PASSWORD = 'reset-password-success',
    OVERLAY_DOI = 'doi-success',
}
